import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="pt-16 lg:pt-20"
    >
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-700 dark:from-blue-950 dark:to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Politique de Confidentialité
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="space-y-8 text-gray-700 dark:text-gray-300"
          >
            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                1. Introduction
              </h2>
              <p className="mb-4">
                M.A.M Consulting est engagée à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                2. Données Collectées
              </h2>
              <p className="mb-4">
                Nous collectons les informations suivantes lorsque vous nous contactez :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Nom de l'entreprise</li>
                <li>Contenu de votre message</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                3. Utilisation des Données
              </h2>
              <p className="mb-4">
                Vos données personnelles sont utilisées pour :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Répondre à vos demandes de contact</li>
                <li>Vous fournir des informations sur nos services</li>
                <li>Améliorer notre site web et nos services</li>
                <li>Vous envoyer des communications relatives à nos services (si vous avez accepté)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                4. Protection des Données
              </h2>
              <p className="mb-4">
                M.A.M Consulting met en place des mesures de sécurité appropriées pour protéger vos données personnelles contre l'accès non autorisé, la modification ou la divulgation. Nous utilisons le chiffrement SSL et d'autres technologies de sécurité standard.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                5. Partage des Données
              </h2>
              <p className="mb-4">
                Nous ne partageons vos données personnelles avec des tiers que si :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Vous nous y avez autorisés</li>
                <li>C'est nécessaire pour fournir les services demandés</li>
                <li>La loi l'exige</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                6. Cookies
              </h2>
              <p className="mb-4">
                Notre site utilise des cookies pour améliorer votre expérience de navigation. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter la fonctionnalité du site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                7. Vos Droits
              </h2>
              <p className="mb-4">
                Vous avez le droit de :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Accéder à vos données personnelles</li>
                <li>Corriger vos données inexactes</li>
                <li>Demander la suppression de vos données</li>
                <li>Vous opposer au traitement de vos données</li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous à : contact@mam-consulting.biz
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                8. Modifications de la Politique
              </h2>
              <p className="mb-4">
                M.A.M Consulting se réserve le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec la date de dernière mise à jour.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                9. Contact
              </h2>
              <p className="mb-4">
                Pour toute question concernant cette politique de confidentialité, veuillez nous contacter :
              </p>
              <p className="mb-2">
                <strong>Email :</strong> contact@mam-consulting.biz
              </p>
              <p>
                <strong>Téléphone :</strong> +237 699 187 929
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Privacy;